import { render, staticRenderFns } from "./insure-plan.vue?vue&type=template&id=43e1523d&scoped=true&"
import script from "./insure-plan.vue?vue&type=script&lang=js&"
export * from "./insure-plan.vue?vue&type=script&lang=js&"
import style0 from "./insure-plan.vue?vue&type=style&index=0&id=43e1523d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e1523d",
  null
  
)

export default component.exports